<template>
  <div class="box container">
    <!-- DROP MEUN -->
    <div class="topDiv">
        <b-dropdown aria-role="list">
          <b-icon 
            class="m-r-20px m-t-20px interactive" 
            slot="trigger" 
            pack="fas" icon="ellipsis-h" 
            size="is-small">
          </b-icon>
          <b-dropdown-item 
            aria-role="listitem" 
            @click="removeLink(link.order)">
              DELETE
          </b-dropdown-item>
        </b-dropdown>
    </div>
    <div class="linkEditor">
      <!-- DRAGG GRIPPER -->
      <b-icon class="cent-vet gripper handle" pack="fas" size="is-medium" icon="grip-lines-vertical">
      </b-icon>
      <!-- ICON -->
      <b-tooltip label="Change icon" position="is-left" >
        <b-icon class="cent-vet interactive" 
          pack="fab" 
          :icon="link.icon||'whatsapp'"  
          @click.native="$emit('icon-click',link)"
          >
        </b-icon>
      </b-tooltip>
      <!-- INPUTS -->
      <div class="vertical ">
        <b-field label="Tittle" label-position="on-border">
          <b-input @blur="saveLinkChange()" v-model="link.name"></b-input>
        </b-field>
        
        <b-field label="Url" label-position="on-border">
          <!-- <p class="control">
            <span class="button is-static">https://</span>
          </p> -->
          <b-input @blur="saveLinkChange()" v-model="link.url" expanded></b-input>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'

  export default {
    name: 'linkEditor',
    props: {
      link: Object,
    },
    data() {
      return {
      }
    },
    methods: {
      ...mapActions(['removeLink','saveLinkChange']),
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '@/assets/vars.scss';
  .topDiv{
    text-align: right;
    height: 15px;
  }
  .container{
    padding:0;
    background: #E4E4E4;
    border-radius: 20px;
    box-shadow: 0;
  }
  .linkEditor {
    text-align: left;
    padding: 0;
    display: flex;
    margin:10px auto;
  }

  .m-t-20px {
    margin-top: 20px;
  }

  .m-r-20px {
    margin-right: 20px;
  }

  .vertical {
    height: 100%;
    width: -webkit-fill-available;
    padding: 5px;
  }

  .field {
    margin: 5px 0;
  }

  .cent-vet {
    margin: auto 0;
  }

  .gripper {
    margin: auto 5px;

    &:hover {
      cursor: move;
    }
  }
</style>